import * as states from '../../../assets/formSchemas/states.json'
import * as copy from '../../../assets/formSchemas/roleCopy.json'
import * as description from '../../../assets/formSchemas/descriptionCopy.json'

// ---- Fetch Local Data ----
export const getStates = () => {
  return states.data
}

export const getCopy = () => {
  return copy
}

export const getDescription = () => {
  return description
}

// ---- Toast ----
export const dispatchToast = async ({ commit }) => {
  commit('SET_TOAST')
}

export const newMessageToast = async ({ commit }, message) => {
  commit('TOAST_MESSAGE', `From: ${message.sender.name}`)
}

// ---- Nav ----
export const toggleMobileNav = async ({ commit }) => {
  commit('TOGGLE_MOBILE_NAV')
}

export const resetMobileNav = async ({ commit }) => {
  commit('RESET_MOBILE_NAV')
}

// ---- Spinner ----
export const toggleSpinner = ({ commit, state }, data) => {
  commit('TOGGLE_SPINNER', data)
}

// ---- Utils ----
export const getErrors = ({ commit }, formErrors) => {
  let i = 0
  let loginErrors = []
  for (let key in formErrors) {
    let errorLength = formErrors[key].length
    for (i = 0; i < errorLength; i++) {
      loginErrors.push(formErrors[key][i])
    }
  }
  return loginErrors
}

export const checkNested = (storeObj, nestedObj) => {
  let args = nestedObj.props
  let obj = nestedObj.obj

  for (let i = 0; i < args.length; i++) {
    if (!obj || !obj.hasOwnProperty(args[i])) {
      return false
    }
    obj = obj[args[i]]
  }
  return obj
}



// WEBPACK FOOTER //
// ./src/app/store/misc/actions.js